import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { CloseControl } from '../../../primitives/Tooltip/Layer/components/CloseControl.js';
import { Container } from '../../../primitives/Tooltip/Layer/components/Container.js';
import { Content } from '../../../primitives/Tooltip/Layer/components/Content.js';
import { Title } from '../../../primitives/Tooltip/Layer/components/Title.js';
const Component = forwardRef(({
  title,
  arrow,
  children,
  onClose,
  ...restProps
}, ref) => {
  const closeControl = typeof onClose === 'function' ? _jsx(CloseControl, {
    onClick: onClose
  }) : null;
  return _jsxs(Container, {
    ...restProps,
    ref: ref,
    children: [closeControl, _jsxs(Content, {
      children: [title && _jsx(Title, {
        children: title
      }), children]
    }), arrow]
  });
});
export const Layer = /*#__PURE__*/_styled(Component, process.env.NODE_ENV === "production" ? {
  target: "e1udu1n90"
} : {
  target: "e1udu1n90",
  label: "Layer"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVd1QyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ2xvc2VDb250cm9sIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9Ub29sdGlwL0xheWVyL2NvbXBvbmVudHMvQ2xvc2VDb250cm9sLmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvVG9vbHRpcC9MYXllci9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBDb250ZW50IH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9Ub29sdGlwL0xheWVyL2NvbXBvbmVudHMvQ29udGVudC5qcyc7XG5pbXBvcnQgeyBUaXRsZSB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvVG9vbHRpcC9MYXllci9jb21wb25lbnRzL1RpdGxlLmpzJztcbmNvbnN0IENvbXBvbmVudCA9IGZvcndhcmRSZWYoKHsgdGl0bGUsIGFycm93LCBjaGlsZHJlbiwgb25DbG9zZSwgLi4ucmVzdFByb3BzIH0sIHJlZikgPT4ge1xuICAgIGNvbnN0IGNsb3NlQ29udHJvbCA9IHR5cGVvZiBvbkNsb3NlID09PSAnZnVuY3Rpb24nID8gX2pzeChDbG9zZUNvbnRyb2wsIHsgb25DbGljazogb25DbG9zZSB9KSA6IG51bGw7XG4gICAgcmV0dXJuIChfanN4cyhDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCByZWY6IHJlZiwgY2hpbGRyZW46IFtjbG9zZUNvbnRyb2wsIF9qc3hzKENvbnRlbnQsIHsgY2hpbGRyZW46IFt0aXRsZSAmJiBfanN4KFRpdGxlLCB7IGNoaWxkcmVuOiB0aXRsZSB9KSwgY2hpbGRyZW5dIH0pLCBhcnJvd10gfSkpO1xufSk7XG5leHBvcnQgY29uc3QgTGF5ZXIgPSBzdHlsZWQoQ29tcG9uZW50KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */");